import { render } from "./dashboard-filters.vue?vue&type=template&id=48a573d6&scoped=true&ts=true"
import script from "./dashboard-filters.vue?vue&type=script&lang=ts"
export * from "./dashboard-filters.vue?vue&type=script&lang=ts"

import "./dashboard-filters.vue?vue&type=style&index=0&id=48a573d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a573d6"]])

export default __exports__